import { ChangeDetectorRef, Component, ComponentRef, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { NotificationComponent } from '../../shared/notification/notification.component';
import { ComponentPortal } from '@angular/cdk/portal';
import { NotificationType } from '../../domain/model/enums/notificationType';
import { AccountService } from '../../domain/service/accountService';
import { Icons } from '../../enums/icons-enums';

@Component({
  selector: 'app-code-confirmation',
  templateUrl: './code-confirmation.component.html',
  styleUrl: './code-confirmation.component.css'
})
export class CodeConfirmationComponent implements OnInit, OnDestroy {
  private overlayRef!: OverlayRef;
  public isCodeValid: boolean = false;
  public icons = Icons
  constructor(private accountService: AccountService, private readonly router: Router,
    private readonly localStorage: LocalStorageService,
    private readonly route: ActivatedRoute, private overlay: Overlay, private cdr: ChangeDetectorRef) {
  }
  ngOnDestroy(): void {
    //  this.overlayRef.detach();
  }

  ngOnInit(): void {
    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy: this.overlay
        .position()
        .global()
        .top("20px")
        .right("30px"),
    });
    this.route.paramMap.subscribe(params => {
      this.email = params.get('email') ?? '';
      // use id as needed
    });
  }
  code: string = '';
  codeComplete: boolean = false;
  email: string = '';
  // this called every time when user changed the code
  onCodeChanged(code: string) {
    this.isCodeValid = code.replaceAll("-", "").length == 4;
    this.code = code;
    this.cdr.detectChanges();
  }
  showNotification(message: string, title: string, notificationType: NotificationType): void {
    // Create a Portal instance of our `NotificationComponent`
    const notificationPortal = new ComponentPortal(NotificationComponent);
    // Attach our `NotificationComponent` to the Overlay Portal
    const notificationRef: ComponentRef<NotificationComponent> =
      this.overlayRef.attach(notificationPortal);
    // Now we can access the component instance
    // and we can pass input for the `message` prop we created.
    notificationRef.instance.message = message;
    notificationRef.instance.title = title;
    notificationRef.instance.type = notificationType;
    notificationRef.instance.overlayRef = this.overlayRef;
    notificationRef.instance.getColor();

    // Set a timeout to detach our component from the overlay
    // after 3000 milliseconds
    setTimeout(() => {
      this.overlayRef.detach();
    }, 3000);
  }
  // this called only if user entered full code
  onCodeCompleted(code: string) {
    this.codeComplete = true;
  }
  backToLogin() {
    this.router.navigate(['/forgotPassword']);
  }
  validateCode() {
    this.accountService.validateCode(this.email, this.code).subscribe({
      next: (response) => {

      },
      error: (error) => {
        this.showNotification('The confirmation code you entered is invalid. Please check the code and try again.', 'Verification code', NotificationType.Error);

      },
      complete: () => {
        this.showNotification('Your confirmation code was correct.', 'Confirmation code validated', NotificationType.Success);
        this.router.navigate(['/setNewPassword', this.email]);
      }
    });

  }
  resendCode() {
    this.accountService.generateCode(this.email);
    this.showNotification('A new confirmation code has been sent to your email. Please check your inbox and try again.', 'Verification code', NotificationType.Success);

  }
}
